import { useState } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { Question } from "@phosphor-icons/react";

/**
 * Small "?" icon that shows a plain-English explanation on hover/click.
 * Drop next to any label, heading or button that isn't self-explanatory.
 * Usage: <HelpTip text="What this does, in one or two short sentences." />
 */
export default function HelpTip({ text, side = "top" }) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipPrimitive.Provider delayDuration={150}>
      <TooltipPrimitive.Root open={open} onOpenChange={setOpen}>
        <TooltipPrimitive.Trigger asChild>
          <button
            type="button"
            data-testid="help-tip"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
            aria-label="Help"
            className="inline-flex items-center justify-center align-middle ml-1.5 shrink-0 rounded-full hover:opacity-100 transition-opacity"
            style={{ color: "var(--text-2)", opacity: 0.75, width: 16, height: 16 }}
          >
            <Question size={14} weight="bold" />
          </button>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={6}
            className="z-[100] max-w-[260px] text-xs leading-relaxed px-3 py-2 shadow-xl"
            style={{ background: "var(--surface)", border: "1px solid var(--line)", color: "var(--text)" }}
          >
            {text}
            <TooltipPrimitive.Arrow style={{ fill: "var(--surface)" }} width={10} height={5} />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
